import styled from "styled-components";
import { Link } from "react-router-dom";
import NavBar from "../components/Navbar";
import AvailabilitySearch from "../components/AvailabilitySearch/AvailabilitySearch";
import * as StyledTexts from "../styledTexts";

const AvailabilityPageContainer = styled.div`
  padding-top: 1rem;
  padding-left: 5rem;
  padding-right: 5rem;
  min-height: 80vh;

  @media (max-width: 768px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const PageIntro = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  color: #595959;
  max-width: 46rem;
  margin: 0 0 2rem 0;

  a {
    color: ${({ theme }) => theme.buttonColors.secondary};
  }
`;

function AvailabilityPage() {
  return (
    <>
      <NavBar />
      <AvailabilityPageContainer>
        <StyledTexts.Title>Find an open week</StyledTexts.Title>
        <PageIntro>
          Pick your dates below to see which of our Cape Cod homes are still
          open. Every home has its own page with photos, list of amenities, and a booking
          request form — or you can{" "}
          <Link to="/contact">contact Yiping Ding</Link> directly with a
          question.
        </PageIntro>

        <AvailabilitySearch />
      </AvailabilityPageContainer>
    </>
  );
}

export default AvailabilityPage;
